<template>
  <div class="produce-wrap">
    <v-nav class="v-nav" :url="'static/img/logo-blue.png'"  :changeMethods="false"></v-nav>
    <div class="title-wrap">
      <v-title class="title" :text="'我们的产品和服务'"></v-title>
    </div>
    <el-carousel class="cards card-rest1" :interval="4000" trigger="click" indicator-position="outside" height="412px">
      <el-carousel-item v-for="item in cardsData" :key="item.id">
        <div class="card-wrap">
          <div class="text">
            <h2>{{item.title}}</h2>
            <p>{{item.con}}</p>
          </div>
          <div class="img">
            <img :src="item.url">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <v-title :text="'我们的优势'"></v-title>
    <div class="strengths">
      <div class="strength develop">
        <div class="cover"></div>
        <img src="../../assets/img/wallet-develop-icon.png"/>
        <h2>快速开发</h2>
        <p>团队已具备成熟的开发及项目经验，可快速实现公有链的开发</p>
      </div>
      <div class="strength order">
        <div class="cover"></div>
        <img src="../../assets/img/wallet-order-icon.png"/>
        <h2>定制化服务</h2>
        <p>针对用户的不同使用需求，可实现智能合约编写、挖矿机制优化、共识机制修改等区块链主流技术特性的定制化开发</p>
      </div>
      <div class="strength technology">
        <div class="cover"></div>
        <img src="../../assets/img/wallet-technology-icon.png"/>
        <h2>跨链技术</h2>
        <p>核心跨链技术，满足多种资产直接刚性兑换的需求，实现链与链之间以去中心化的方式进行价值传递</p>
      </div>
    </div>
    <v-footer class="foot"></v-footer>
  </div>
</template>

<script>
  import VNav from "../plug/Nav";
  import VTitle from "../plug/VTitle";
  import VFooter from "../plug/VFooter";

  export default {
    components: {
      VFooter,
      VTitle,
      VNav
    },
        name: "heavyWallet",
    data() {
      return {
        cardsData: [
          {
            id: 0,
            title: '提供区块链完整功能及对外接口',
            con: '公有链开发完整功能支持，提供底层区块链程序和钱包',
            url: 'static/img/wallet-p1.png'
          },
          {
            id: 1,
            title: '资产交易及查询服务',
            con: '优化操作流程，支持兑换、充值、提现、转账等链上及跨链交易',
            url: 'static/img/wallet-p2.png'
          },
          {
            id: 2,
            title: '智能合约及其衍生服务',
            con: '通过使用智能合约，灵活扩展定制复杂的交易逻辑，以及复杂金融合约等。在不对链本身代码进行修改更新的基础上，有限制可控地动态扩展功能',
            url: 'static/img/wallet-p3.png'
          }
        ]
      };
    }
    }
</script>

<style lang="less" scoped>
  .produce-wrap {
    .v-nav {
      color: #333333;
    }
    .title-wrap {
      position: relative;
      height: 20%;
      .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -100%);
      }
    }
    .cards {
      width: 75%;
      min-width: 800px;
      margin: 128px auto 250px;
      .card-wrap {
        display: flex;
        .text {
          flex: 1;
          h2 {
            font-size: 2.25rem;
            margin-top: 118px;
          }
          p {
            font-size: 1.5rem;
            color: #999999;
            margin-top: 20px;
          }
        }
        .img {
          flex: 1;
          text-align: center;
          img {
            vertical-align: middle;
          }
        }
      }
    }
    .strengths {
      width: 80%;
      height: 50%;
      min-width: 1080px;
      margin: 140px auto 200px;
      display: flex;
      justify-content: space-between;
      .strength {
        width: 366px;
        height: 428px;
        position: relative;
        color: white;
        cursor: pointer;
        @media screen and (max-width: 1500px) {
          width: 296px;
          height: 388px;
        }
        img {
          display: block;
          position: absolute;
          left: 140px;
          top: 115px;
          z-index: 15;
          transition: 500ms;
          @media screen and (max-width: 1500px) {
            width: 90px;
            left: 105px;
          }
        }
        h2 {
          position: absolute;
          text-align: center;
          width: 100%;
          left: 0;
          top: 289px;
          font-size: 1.8rem;
          z-index: 15;
          transition: 500ms;
          @media screen and (max-width: 1500px) {
            top: 259px;
          }
        }
        p {
          position: absolute;
          overflow: hidden;
          text-align: center;
          width: 208px;
          height: 0;
          left: calc(~'50% - 104px');
          bottom: 20px;
          font-size: 1.25rem;
          z-index: 15;
          transition: 500ms;
        }
      }
      .develop {
        background: url("../../assets/img/wallet-develop.png");
        background-size: 100% 100%;
      }
      .order {
        background: url("../../assets/img/wallet-order.png");
        background-size: 100% 100%;
        img {
          left: 113px;
          @media screen and (max-width: 1500px) {
            left: 105px;
          }
        }
      }
      .technology {
        background: url("../../assets/img/wallet-technology.png");
        background-size: 100% 100%;
        img {
          left: 118px;
          @media screen and (max-width: 1500px) {
            left: 105px;
          }
        }
      }
      .cover {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .54);
        z-index: 10;
      }
      .strength:hover .cover {
        background: rgba(19, 168, 254, .43);
      }
      .strength:hover img {
        transform: translateY(-57px);
      }
      .strength:hover h2 {
        transform: translateY(-57px);
      }
      .strength:hover p {
        height: 114px;
      }
    }
    .foot {
      height: 100px;
      @media screen and (max-width: 1500px){
        height: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/heavyWallet/HeavyWallet.vue